import React from 'react';
import { Venue } from '../../types/venue';
import { BuildingOfficeIcon, MapPinIcon, UsersIcon, Square2StackIcon } from '@heroicons/react/24/outline';

interface VenueCardProps {
  venue: Venue;
  onEdit: (venue: Venue) => void;
  onDelete: (id: number) => void;
}

const VenueCard: React.FC<VenueCardProps> = ({ venue, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-lg shadow hover:shadow-md transition-shadow p-3 md:p-6">
      <div className="flex items-start justify-between mb-2 md:mb-4">
        <div className="flex items-center space-x-2 md:space-x-3 min-w-0">
          <div className="flex-shrink-0 h-9 w-9 md:h-12 md:w-12 rounded-lg bg-primary-100 flex items-center justify-center">
            <BuildingOfficeIcon className="h-5 w-5 md:h-6 md:w-6 text-primary-600" />
          </div>
          <div className="min-w-0">
            <h3 className="text-sm md:text-lg font-semibold text-gray-900 break-words">{venue.name}</h3>
            {venue.address && (
              <div className="flex items-center text-xs md:text-sm text-gray-500 mt-1 min-w-0">
                <MapPinIcon className="h-4 w-4 mr-1 shrink-0" />
                <span className="truncate md:whitespace-normal">{venue.address}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {venue.description && (
        <p className="text-xs md:text-sm text-gray-600 mb-2 md:mb-4 line-clamp-2">{venue.description}</p>
      )}

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 md:gap-x-4 text-xs md:text-sm text-gray-500 mb-2 md:mb-4">
        <div className="flex items-center">
          <UsersIcon className="h-4 w-4 mr-1" />
          <span>Kapacitás: {venue.capacity}</span>
        </div>
        <div className="flex items-center">
          <Square2StackIcon className="h-4 w-4 mr-1" />
          <span>{venue.sections} rész</span>
        </div>
      </div>

      <div className="flex space-x-2 pt-2 md:pt-4 border-t border-gray-200">
        <button
          onClick={() => onEdit(venue)}
          className="flex-1 px-2 py-1.5 text-xs md:px-4 md:py-2 md:text-sm font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          Szerkesztés
        </button>
        <button
          onClick={() => onDelete(venue.id)}
          className="flex-1 px-2 py-1.5 text-xs md:px-4 md:py-2 md:text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500"
        >
          Törlés
        </button>
      </div>
    </div>
  );
};

export default VenueCard;
